import { __makeTemplateObject } from "tslib";
import { SVG } from '@at/design-system-elements';
import { ThemeSelectors, TypeFiesta } from '@at/design-system-foundation';
import styled from 'styled-components';
export var StyledActionIcon = styled(SVG)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    fill: ", ";\n"], ["\n    fill: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.icon.default;
});
export var StyledActionContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background-color: ", ";\n    margin: ", ";\n    padding: ", ";\n    border-radius: ", ";\n\n    p + p {\n        margin: 0;\n    }\n"], ["\n    background-color: ", ";\n    margin: ", ";\n    padding: ", ";\n    border-radius: ", ";\n\n    p + p {\n        margin: 0;\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.bgFill.soft;
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupFourSpacing(theme);
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupFourSpacing(theme);
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupFourSpacing(theme);
});
export var StyledActionTitleContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    width: 100%;\n    gap: ", ";\n"], ["\n    display: flex;\n    width: 100%;\n    gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupOneSpacing(theme);
});
export var StyledActionTitle = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    width: 85%;\n"], ["\n    width: 85%;\n"])));
export var StyledActionTitleText = styled(TypeFiesta)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-top: calc(", " / 2);\n"], ["\n    margin-top: calc(", " / 2);\n"])), function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupThreeSpacing(theme);
});
export var StyledActionTitleIcon = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-top: ", ";\n\n    svg {\n        height: ", ";\n        width: ", ";\n    }\n"], ["\n    margin-top: ", ";\n\n    svg {\n        height: ", ";\n        width: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getGroupOneSpacing(theme);
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getRelatedOneSpacing(theme);
}, function (_a) {
    var theme = _a.theme;
    return ThemeSelectors.getRelatedOneSpacing(theme);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
